import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import { DomUtils } from "@tento-ui/dom";

@component({ name: "std-blog-bear-footer" })
export class BlogBearFooter extends LonaWebComponent {
  bind(props: BlogBearFooter.Props): this {
    for (const $line of props.lines) {
      $line.slot = "footer-line";
    }
    DomUtils.reconcileChildren(this, props.lines);
    return this;
  }

  static $html: Option<HTMLTemplateElement> = html`
    <footer id="root">
      <slot name="footer-line"></slot>
    </footer>
  `;

  static $styles = [
    css`
      :host {
        display: block;
        width: 100%;
      }

      #root {
        max-width: var(--max-width, 720px);
        margin: 0 auto;
        padding: 24px var(--brand-inline-padding, 40px) 48px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      ::slotted([slot="footer-line"]) {
        display: block;
      }
    `,
  ];
}

export namespace BlogBearFooter {
  export type Props = {
    lines: HTMLElement[];
  };
}
